import branchManagementStopPerformanceComponent from './stop_performance.component';

let branchManagementStopPerformanceModule = angular.module('branchManagementStopPerformance', [])

    .component('branchManagementStopPerformance', branchManagementStopPerformanceComponent)
    .name;

export default branchManagementStopPerformanceModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/stop_performance/index.js